// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductCondensedStyles } from "@awc/Overrides/Components/ProductCarouselProductCondensed";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductCondensedStyles.container = {
    gap: 0,
};
productCarouselProductCondensedStyles.imageGridItem = {
    width: 12,
};

productCarouselProductCondensedStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 100%;
            padding: 4px;
            border: 1px solid ${color("common.ui24")};
            position: relative;
            &:hover {
                border: 1px solid ${color("common.ui25")};
            }
        `,
    },
};
